import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>({
    close: {
        cursor: 'pointer'
    },
}));
